// The canonical list of commands. Every action the dispatcher can
// reach via the palette, a hotkey, the cheatsheet, or the
// right-click menu lives here. Adding a command is a one-touch
// operation: declare it, ship it.
//
// Conventions:
//   - id is "<domain>.<verb>" (snake_case verbs), stable forever.
//   - hotkeys for navigation own ⌘1..⌘9.
//   - mutation hotkeys belong to the entity being mutated; the
//     scope guarantees the hotkey only resolves when the entity
//     is in context.
//   - destructive commands MUST set confirmation.destructive=true.
import { commandsNav } from "@/lib/commands/registry-nav";
import { commandsContext } from "@/lib/commands/registry-context";
import { commandsDispatch } from "@/lib/commands/registry-dispatch";
import { commandsFulfillment } from "@/lib/commands/registry-fulfillment";
import { commandsPayouts } from "@/lib/commands/registry-payouts";
import { commandsBilling } from "@/lib/commands/registry-billing";
import { commandsPricing } from "@/lib/commands/registry-pricing";
import type { Command } from "@/lib/commands/types";

export const commands: Command[] = [
  ...commandsNav,
  ...commandsContext,
  ...commandsDispatch,
  ...commandsFulfillment,
  ...commandsPayouts,
  ...commandsBilling,
  ...commandsPricing,
];

// commandById is a tiny lookup helper used by the context menu and
// telemetry surface to resolve a command from its id without a
// full Array.prototype.find on every render.
const byId = new Map(commands.map((c) => [c.id, c]));
export function commandById(id: string): Command | undefined {
  return byId.get(id);
}
